// extracted by mini-css-extract-plugin
export default {"accountsContainer":"calculationAccounts_accountsContainer__AgC5I","accountsHeader":"calculationAccounts_accountsHeader__GgGVq"};